export default __webpack_public_path__ + "static/pie-chart-fees-dbb4c5edc163d30350e099e4af155b7f.svg";